import { useAdmin } from '@vtex/raccoon-next'
import { useMemo } from 'react'

export function useSearchParams() {
  const { path } = useAdmin()

  const params = useMemo(
    () => new URLSearchParams((path ?? '').split('?')[1]),
    [path]
  )
  return { params }
}
